import React from "react";
import type {VoidFunctionComponent} from "react";
import s from "./SongsMobileFilterPanel.module.scss";
import {
  SongsMobileFilterGroupDifficulty
} from "../../modules/mobile-filter-group-difficulty/SongsMobileFilterGroupDifficulty";
import {SongsMobileFilterGroupGenres} from "../../modules/mobile-filter-group-genres/SongsMobileFilterGroupGenres";
import {
  SongsMobileFilterGroupFeatures
} from "../../modules/mobile-filter-group-features/SongsMobileFilterGroupFeatures";

export const SongsMobileFilterPanel: VoidFunctionComponent = () => {
  return (
    <div className={s.container}>
      <SongsMobileFilterGroupDifficulty />
      <SongsMobileFilterGroupGenres />
      <SongsMobileFilterGroupFeatures />
    </div>
  );
}
